import Vue from 'vue';
import PortalSettings from '@/models/PortalSettings';
import moment from 'moment';

class Formatter {
  currency(num, numDigits=2, useBaseCurrency=false) {
    let currency = PortalSettings.get('currency', {});
    let code = (useBaseCurrency ? currency.default : currency.active || currency.default).toUpperCase();
    let rate = currency.rates[code] || 1.0;
    let options = code ? { style: 'currency', currency: code, currencyDisplay: 'symbol', minimumFractionDigits: numDigits, maximumFractionDigits: numDigits } : undefined;
    num *= rate;
    return num !== undefined ? num.toLocaleString(undefined, options) : num;    
  }

  baseCurrency(num, numDigits=2) {
    return this.currency(num, numDigits, true);
  }

  time(timeString, outFormat='h:mm a', inFormat='HH:mm:ss') {
    return moment(timeString, inFormat).format(outFormat);
  }

  duration(num, unit='minutes') {
    return num ? moment.duration(num, unit).toISOString().replace('PT','').replace('D', 'D ').replace('H', 'H ').toLowerCase().trim() : '';
  }

  date(dateString, outFormat='dddd, MMM D, YYYY', inFormat='YYYY-MM-DD') {
    return moment(dateString, inFormat).format(outFormat);
  }

  percentage(num, minimumFractionDigits = 2) {
    return num.toLocaleString(undefined, { style: 'percent', minimumFractionDigits });
  }  
}

const FormatterPlugin = {
  install(VueObj, options) {
    VueObj.prototype.$formatter = new Formatter();
  }
};

Vue.use(FormatterPlugin);
